/**
 * Generates a stable, premium color theme based on a string input.
 * Returns an object with background, text, and border colors in HSL format.
 */
export const generateBadgeTheme = (name) => {
  if (!name) return { bg: "#f3f4f6", text: "#374151", border: "#e5e7eb" };

  // Stable Hash
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash % 360);
  
  // Premium Soft UI parameters
  // Saturation: 65-75% for soft but colorful look
  // Lightness: 92% for background (very soft), 25% for text (readable)
  const saturation = 70;
  
  return {
    bg: `hsl(${hue}, ${saturation}%, 92%)`,
    text: `hsl(${hue}, ${saturation + 10}%, 25%)`,
    border: `hsl(${hue}, ${saturation}%, 82%)`,
    hue: hue
  };
};
